<script>
  import Router, { push, pop } from "svelte-spa-router"
  import { beforeUpdate, onDestroy, onMount } from "svelte"
  import ApplicationState from "./Stores/applicationStates"
  import { parseJWT } from "./Script/token"
  import sha256 from "crypto-js/sha256"
  import NotificationSystem from "./Shared/Notification/index.svelte"
  import routes from "./Routes/index"
  import FeatureModal from "./Shared/featureModal.svelte"
  import notify from "./Script/notify"
  import FeatureState from "./Stores/featureState"
  import { getRequest } from "./Script/apiMethods"

  let updates = []

  let updateCount = 0

  onMount(() => {
    const load = document.getElementById("mainLoader")
    load.style.display = "none"
    const mainContent = document.getElementById("mainContent")
    mainContent.style.display = "block"
  })

  const routeEvent = (event) => {
    if (event.detail.location != "/") {
      if (!$ApplicationState.token) {
        return push("/")
      }
      let parsedJwt = parseJWT($ApplicationState.token)

      if (parsedJwt.exp * 1000 - Date.now() < 12 * 60 * 60 * 1000) {
        $ApplicationState.token = null
        $ApplicationState.msignToken = null
        localStorage.clear()
        push("/")
        return
      }

      if (Date.now() > parsedJwt.exp * 1000) {
        $ApplicationState.token = null
        $ApplicationState.msignToken = null
        localStorage.clear()
        return push("/")
      }

      if (sha256($ApplicationState.token).toString() != $ApplicationState.tokenhmac) {
        $ApplicationState.token = null
        $ApplicationState.msignToken = null

        localStorage.clear()
        return push("/")
      }

      // if (event.detail.location.startsWith("/signing/") && (!$ApplicationState.pdfEnabled || !$ApplicationState.msignToken)) push("/404")
    }
  }

  const addDarkMode = () => {
    if ($ApplicationState.darkMode) document.body.classList.add("dark")
    else document.body.classList.remove("dark")
  }

  $: addDarkMode($ApplicationState.darkMode)

  // $: onUpdateView($FeatureState.showUpdates)

  // const onUpdateView = async () => {
  //   try {
  //     if ($FeatureState.showUpdates) await fetchFeatures()
  //   } catch (error) {
  //     console.error(error)
  //     const info = "PAGE: Global\nEVENT: While fetching application update list"
  //     notify.danger(error, info)
  //   }
  // }

  // const fetchFeatures = async () => {
  //   try {
  //     const features = await getRequest("/api/app-updates/v1/app-update/fetch", {
  //       headers: {
  //         "x-access-token": $ApplicationState.token,
  //       },
  //     })

  //     if (!features.updates.length) throw "No updates found"

  //     if (updateCount != features.count) {
  //       updates = [...updates, ...features.updates]
  //       updateCount = features.count
  //     }
  //   } catch (error) {
  //     throw error
  //   }
  // }

  const handleBeforeRouteLoading = (e) => {
    if (!$ApplicationState.pdfEnabled) {
      if (e.detail.location.startsWith("/signing/")) {
        push("/404")
      }
    } else {
      if (e.detail.location.startsWith("/signing/")) {
        if (!$ApplicationState.msignToken) {
          notify.danger("Signing is currently unavailable. Please try again later.")
          pop() // Redirects back to the previous page
        }
      }
    }
  }

  const onUnhandledRejection = (e) => {
    try {
      throw e.reason
    } catch (error) {
      // console.error(error)
      const info = "PAGE: Global\nEVENT: While catching unhandled rejection throughout the application"
      notify.danger(error, info)
    }
  }
</script>

<svelte:window on:unhandledrejection={onUnhandledRejection} />

<div>
  <!-- {#if $FeatureState.showUpdates}
    <FeatureModal
      bind:updates
      {updateCount}
      on:close={() => {
        $FeatureState.showUpdates = false
      }}
      on:click={() => {
        $FeatureState.showUpdates = false
        $FeatureState.notifyUser = false
      }}
    />
  {/if} -->
  <Router {routes} on:routeLoading={handleBeforeRouteLoading} on:routeLoaded={routeEvent} />
</div>

<NotificationSystem />

<style global lang="postcss">
  @tailwind base;
  @tailwind components;
  @tailwind utilities;

  @layer base {
    html {
      -webkit-tap-highlight-color: transparent;
    }
  }

  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active {
    -webkit-background-clip: text;
    -webkit-text-fill-color: #ffffff;
    transition: background-color 5000s ease-in-out 0s;
    box-shadow: inset 0 0 20px 20px #23232329;
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  input[type="number"] {
    -moz-appearance: textfield;
  }

  /* width */
  ::-webkit-scrollbar {
    width: 5px;
    height: 2px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: #f1f1f1;
  }
  .dark::-webkit-scrollbar-track,
  .dark * ::-webkit-scrollbar-track {
    background: #424242;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 8px;
  }
  /* Handle */
  .dark::-webkit-scrollbar-thumb,
  .dark * ::-webkit-scrollbar-thumb {
    background: #686868;
    border-radius: 8px;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
  }
  /* Handle on hover */
  .dark::-webkit-scrollbar-thumb:hover,
  .dark * ::-webkit-scrollbar-thumb:hover {
    background: #7b7b7b;
  }

  .wordBreak {
    word-break: break-word;
  }

  body {
    font-family: "Nunito", sans-serif;
  }
  /*This would all go into the global.css file*/
  [data-tooltip] {
    position: relative;
    /* z-index: 1000; */
    display: inherit;
  }

  [data-tooltip]:before,
  [data-tooltip]:after {
    visibility: hidden;
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.2s ease-in-out;
    /* animation-delay: 3s; */
    /* transition-delay: 1s; */
    /* transform: translate(-50%, 5px); */
  }

  [tooltip-position="top"]:before {
    /* top */
    margin-bottom: 5px;
    bottom: 100%;
    left: 50%;
  }
  [tooltip-position="bottom"]:before {
    /* bottom */
    margin-top: 5px;
    top: 100%;
    left: 50%;
  }
  [tooltip-position="right"]:before {
    /* right */
    margin-left: 6.8px;
    left: 100%;
    top: 50%;
  }
  [tooltip-position="left"]:before {
    /* left */
    margin-right: 6.8px;
    right: 100%;
    top: 50%;
  }

  [data-tooltip]:before {
    position: absolute;
    word-break: break-all;

    padding: 7px;
    width: max-content;
    max-width: 100vh;
    -webkit-border-radius: 3px;
    -moz-border-radius: 3px;
    border-radius: 3px;
    /* background-color: #666666; */
    background-color: #464646;
    color: #fff;
    content: attr(data-tooltip);
    text-align: center;
    font-size: 14px;
    line-height: 1.2;
    /* transition: 0.2s ease-out; */
  }

  [tooltip-position="top"]:after {
    /* top */
    /* border-top: 5px solid #666666; */
    border-top: 5px solid #464646;
    bottom: 100%;
    left: 50%;
    border-right: 5px solid transparent;
    border-left: 5px solid transparent;
  }
  [tooltip-position="bottom"]:after {
    /* bottom */
    top: 100%;
    left: 50%;
    /* border-bottom: 5px solid #666666; */
    border-bottom: 5px solid #464646;
    border-right: 5px solid transparent;
    border-left: 5px solid transparent;
  }
  [tooltip-position="right"]:after {
    /* right */
    margin-left: 2px;
    left: 100%;
    top: 50%;
    /* border-right: 5px solid #666666; */
    border-right: 5px solid #464646;
    border-top: 5px solid transparent;
    border-bottom: 5px solid transparent;
  }
  [tooltip-position="left"]:after {
    /* left */
    margin-right: 2px;
    right: 100%;
    top: 50%;
    /* border-left: 5px solid #666666; */
    border-left: 5px solid #464646;
    border-top: 5px solid transparent;
    border-bottom: 5px solid transparent;
  }
  [data-tooltip]:after {
    position: absolute;
    content: " ";
    font-size: 0;
    line-height: 0;
  }

  [tooltip-position="bottom"]:hover:before,
  [tooltip-position="bottom"]:hover:after,
  [tooltip-position="top"]:hover:before,
  [tooltip-position="top"]:hover:after {
    transform: translate(-50%, 0);
  }
  [tooltip-position="right"]:hover:before,
  [tooltip-position="right"]:hover:after,
  [tooltip-position="left"]:hover:before,
  [tooltip-position="left"]:hover:after {
    transform: translate(0, -50%);
  }

  [data-tooltip]:hover:before,
  [data-tooltip]:hover:after {
    visibility: visible;
    z-index: 1000;
    opacity: 1;
  }

  [data-tooltip="false"]:hover:before,
  [data-tooltip="false"]:hover:after {
    visibility: hidden;
    opacity: 0;
  }

  [type="checkbox"]:focus {
    outline: 0;
    outline-offset: 0;
    --tw-ring-inset: none;
    --tw-ring-offset-width: 0;
    --tw-ring-offset-color: transparent;
    --tw-ring-color: transparent;
    --tw-ring-offset-shadow: none;
    --tw-ring-shadow: none;
    box-shadow: none;
  }

  input[type="range"] {
    -webkit-appearance: none;
    appearance: none;
    width: 100%;
    cursor: pointer;
    outline: none;
    border-radius: 15px;

    height: 6px;
    background: #484849;
  }

  /* Thumb: webkit */
  input[type="range"]::-webkit-slider-thumb {
    /* removing default appearance */
    -webkit-appearance: none;
    appearance: none;
    /* creating a custom design */
    height: 15px;
    width: 15px;
    background-color: rgb(34, 0, 255);
    border-radius: 50%;
    border: none;

    /* box-shadow: -407px 0 0 400px #f50; emove this line */
    transition: 0.2s ease-in-out;
  }

  /* Thumb: Firefox */
  input[type="range"]::-moz-range-thumb {
    height: 15px;
    width: 15px;
    background-color: rgb(0, 26, 255);
    border-radius: 50%;
    border: none;

    /* box-shadow: -407px 0 0 400px #f50; emove this line */
    transition: 0.2s ease-in-out;
  }

  /* Hover, active & focus Thumb: Webkit */

  input[type="range"]::-webkit-slider-thumb:hover {
    box-shadow: 0 0 0 5px #0015ff33; /* Reduced size */
  }
  input[type="range"]:active::-webkit-slider-thumb {
    box-shadow: 0 0 0 7px #0015ff33; /* Reduced size */
  }
  input[type="range"]:focus::-webkit-slider-thumb {
    box-shadow: 0 0 0 7px #0015ff33; /* Reduced size */
  }
</style>
